import { TRANSCRIPT_ONLY_LABEL } from '@pages/Libraries/components/TranscriptOnlyIndicator';

/**
 * What the visual panel is called, everywhere it is offered.
 *
 * "Visuals" is the counterpart to "Transcript": between them the two tabs are what was *shown*
 * and what was *said*. It replaced "Summary" / "Visual summary" — the same panel under two
 * names, one per modal — which is why the word is no longer a parameter. There is one place to
 * write it, so the two cannot drift apart again.
 *
 * It is also the longest name the tab row can afford. The row holds four tabs against a 400px
 * minimum panel with about 19px to spare, and `MultipleToggle` cannot shrink — so a longer word
 * here does not wrap, it pushes Comments off the end behind a sideways scroll. See
 * `$panel-column` in `MomentModal.module.scss`, which is derived from this row's width.
 */
export const VISUAL_TAB_LABEL = 'Visuals';

/**
 * Builds the "visual" option for a media modal's panel picker (`PanelTabs` and
 * `BaseMomentModal`).
 *
 * A transcript-only library has no visual descriptions (that's what the panel shows), so the
 * option is marked unavailable via `MultipleToggle`'s `disabledTooltip` — which struck-throughs
 * it, adds `aria-disabled`, shows the explanatory tooltip, and ignores selecting it. Callers
 * don't need their own guard.
 */
export function visualToggleOption(isTranscriptOnly: boolean) {
  return isTranscriptOnly
    ? {
        value: 'visual' as const,
        label: VISUAL_TAB_LABEL,
        disabledTooltip: TRANSCRIPT_ONLY_LABEL,
      }
    : { value: 'visual' as const, label: VISUAL_TAB_LABEL };
}
